import { useState, useEffect, useRef, useCallback } from "react";

// ─── Mock API ─────────────────────────────────────────────────────────────────
// Swap this for: const res = await fetch("https://api.yourdomain.com/v1/gallery"); return res.json();
const MOCK_RESPONSE = {
  featured: [
    { id: 1, title: "Holy Father",  subtitle: "During the King of Kings Coronation",         category: "Holy Father", photographer: "BCS Studio", location: "Nigeria", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F334.jpg?alt=media&token=3313008b-cede-4d0d-9264-2a3686df0ecf" },
    { id: 2, title: "KOK",          subtitle: "The King of Kings",          category: "KOK",         photographer: "BCS Studio", location: "Nigeria", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2FDSC_0101%20-%20Copy.JPG?alt=media&token=3c566bed-e6b8-4d53-95e3-80945cdde675" },
    { id: 3, title: "BCS Members",  subtitle: "Marching together in Faith and Purpose",        category: "Bcs Members", photographer: "BCS Studio", location: "Nigeria", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F0009.jpeg?alt=media&token=03a99916-9edd-4b14-afad-0161798e9250" },
    { id: 4, title: "Holy Father",  subtitle: "The Sole Spiritual Head of the Universe",       category: "Holy Father", photographer: "BCS Studio", location: "Nigeria", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2Fpops.jpeg?alt=media&token=53ccb68b-aa7d-41d3-b8a4-c7f1c02667bd" },
    { id: 5, title: "KOK",          subtitle: "The Great King of the Universe",  category: "KOK",         photographer: "BCS Studio", location: "Nigeria", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2F6.png?alt=media&token=bf8b73cb-f76b-401e-bd02-c6b6ae056c95" },
  ],
  gallery: [
    { id: 10, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F223.jpg?alt=media&token=08db80b2-f214-4887-8624-c8ea56862834" },
    { id: 11, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F0001.jpeg?alt=media&token=de71b79b-be43-4e22-bcf6-8963e5525fd8" },
    { id: 12, title: "KOK",         category: "KOK",         photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2FWeb.png?alt=media&token=4e11abaa-8d29-4d91-8322-2306357d5086" },
    { id: 13, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F0008.jpeg?alt=media&token=650d1264-6124-47a9-b2f2-4ab28034bab1" },
    { id: 14, title: "Holy Father", category: "Holy Father", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2F15609263_1656578644640276_346278321_o.jpg?alt=media&token=f6c28f79-7f54-4dc8-a23d-d17c6b742b0f" },
    { id: 15, title: "KOK",         category: "KOK",         photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2F19599026_1714124838617036_4905401138846290813_n.jpg?alt=media&token=0aeafada-e4f2-482c-b853-e18d5a18855b" },
    { id: 16, title: "KOK",         category: "KOK",         photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2F10698394_375528712624654_7051621203313503290_n.jpg?alt=media&token=ec826ed9-3f56-47b7-adbb-17eb1892028f" },
    { id: 17, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F111.jpg?alt=media&token=af589a4d-5818-424f-a5f8-79edf4b0a895" },
    { id: 18, title: "KOK",         category: "KOK",         photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2F13962595_266657947054181_3500336600462079757_n.jpg?alt=media&token=f60fed5f-9c5e-4890-bd3b-1724161053dc" },
    { id: 19, title: "Holy Father", category: "Holy Father", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2F2%20(2).jpg?alt=media&token=f6448806-8a4f-4486-8679-243b6f380179" },
    { id: 20, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2FDSC_0218.JPG?alt=media&token=a0781671-542e-4fd9-998b-5cb45ee0ae34" },
    { id: 21, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2FDSC_0260.JPG?alt=media&token=38c76430-399c-423b-8e82-818b2974f2c3" },
    { id: 22, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2FDSC_0280.JPG?alt=media&token=1b4ca4e5-ecc4-4c6f-9511-66561653de32" },
    { id: 23, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F221.jpg?alt=media&token=75a02718-dae5-4eed-b3d2-a8dd8eebbaa5" },
    { id: 24, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F114.jpg?alt=media&token=710a9666-dd3c-4313-9db2-4abc65fd1c4a" },
    { id: 25, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2FDSC_0296.JPG?alt=media&token=e2016368-50a7-4885-a550-3e2621287f6b" },
    { id: 26, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F0007.jpeg?alt=media&token=ead7f86d-d69f-4ca8-9568-213b8c32226a" },
    { id: 27, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F0006.jpeg?alt=media&token=b53ef857-2556-4ac5-9995-bd462845ff94" },
    { id: 28, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F0005.jpeg?alt=media&token=12d5bb9f-a6cd-4bc1-92fd-7afc2b173af6" },
    { id: 29, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F0004.jpeg?alt=media&token=5f88a591-e6b0-4273-ab58-5bcbb4c26eff" },
    { id: 30, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F0003.jpeg?alt=media&token=9793bbb8-346e-4f6e-9bf4-1e23f832bf96" },
    { id: 31, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F0002.jpeg?alt=media&token=947f43af-4db5-4a3f-b67d-520faf87a68f" },
    { id: 32, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F00012.jpeg?alt=media&token=0c3c4d74-b1fb-4274-b620-1c784fba0da4" },
    { id: 33, title: "BCS Members", category: "Bcs Members", photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2F331.jpg?alt=media&token=16b75cc7-ad40-4d83-aa76-290087203993" },
    { id: 34, title: "KOK",         category: "KOK",         photographer: "BCS Studio", img: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS2%2Ffacebook-20150322-133736.png?alt=media&token=5ff393fc-96cc-4a56-9be9-368375f40856" },
  ],
};

async function fetchGallery() {
  await new Promise((r) => setTimeout(r, 900));
  // Replace with: const res = await fetch(API_URL); return res.json();
  return MOCK_RESPONSE;
}

// ─── Styles ───────────────────────────────────────────────────────────────────
const CSS = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .g-root {
    background: #f7f4ef;
    color: #fff;
    min-height: 100vh;
    font-family: Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    padding-top: 120px;
  }

  /* ── CAROUSEL ── */
  .carousel-wrap {
    display: flex;
    justify-content: center;
    padding: 2rem clamp(1rem, 5vw, 3rem) 0;
  }

  /* ── CAROUSEL mobile ── */
  @media (max-width: 600px) {
    .g-root {
      padding-top: 0;
    }
    .carousel-wrap {
      padding: 120px 1rem 2rem;
    }
    .carousel {
      width: 94%;
      height: 200px;
      min-height: unset;
      border-radius: 16px;
      margin: 0 auto;
    }
    .carousel img {
      border-radius: 16px;
      filter: brightness(0.50) saturate(0.85);
    }
    .c-text {
      padding: 0.85rem 1rem 1rem;
    }
    .c-eyebrow {
      font-size: 7.5px;
      letter-spacing: 0.16em;
      margin-bottom: 0.35rem;
    }
    .c-title {
      font-size: clamp(1.2rem, 4vw, 1.8rem);
      line-height: 1.1;
    }
    .c-sub {
      font-size: 0.7rem;
      margin-top: 0.28rem;
      line-height: 1.52;
      color: rgba(255,255,255,0.92);
    }
  }
  .carousel {
    position: relative;
    width: 100%;
    max-width: 1500px;
    height: 50vh;
    min-height: 280px;
    overflow: hidden;
    border-radius: 18px;
    background: #d1d1d6;
    cursor: pointer;
    box-shadow: 0 2px 16px rgba(0,0,0,0.10), 0 1px 3px rgba(0,0,0,0.05);
  }
  .c-slide {
    position: absolute; inset: 0;
    opacity: 0;
    transition: opacity 0.75s cubic-bezier(0.4,0,0.2,1);
    will-change: opacity;
  }
  .c-slide.active { opacity: 1; z-index: 2; }
  .c-slide img {
    width: 100%; height: 100%;
    object-fit: cover;
    filter: brightness(0.62) saturate(0.88);
    transform: scale(1.04);
    transition: transform 6s ease;
    pointer-events: none;
  }
  .c-slide.active img { transform: scale(1); }
  .c-vignette {
    position: absolute; inset: 0;
    background:
      linear-gradient(to top, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.10) 46%, transparent 70%),
      linear-gradient(to right, rgba(0,0,0,0.20) 0%, transparent 52%);
    z-index: 3; pointer-events: none;
  }
  .c-text {
    position: absolute; bottom: 0; left: 0; right: 0;
    padding: clamp(1.1rem, 3vw, 1.8rem); z-index: 4; pointer-events: none;
  }
  .c-eyebrow {
    font-size: 9px; letter-spacing: 0.22em; text-transform: uppercase;
    color: #60a5fa; margin-bottom: 0.34rem;
    opacity: 0; transform: translateY(6px);
    transition: all 0.5s 0.1s ease;
  }
  .c-slide.active .c-eyebrow { opacity: 1; transform: none; }
  .c-title {
    font-family: Arial, Helvetica, sans-serif;
    font-size: clamp(2.8rem, 7vw, 6.5rem);
    font-weight: 700;
    line-height: 0.95;
    color: #fff;
    letter-spacing: -0.02em;
    opacity: 0; transform: translateY(12px);
    transition: all 0.65s 0.18s ease;
  }
  .c-slide.active .c-title { opacity: 1; transform: none; }
  .c-subtitle {
    font-size: clamp(0.65rem, 1vw, 0.78rem);
    color: rgba(255,255,255,0.44); margin-top: 0.3rem; letter-spacing: 0.03em;
    opacity: 0; transform: translateY(6px);
    transition: all 0.55s 0.3s ease;
  }
  .c-slide.active .c-subtitle { opacity: 1; transform: none; }
  .c-meta {
    display: flex; gap: 1.1rem; margin-top: 0.6rem;
    font-size: 9px; color: rgba(255,255,255,0.30); letter-spacing: 0.05em;
    opacity: 0; transform: translateY(5px);
    transition: all 0.5s 0.4s ease;
  }
  .c-slide.active .c-meta { opacity: 1; transform: none; }
  .c-meta span::before { content: '— '; color: #60a5fa; }

  .c-controls {
    position: absolute; top: 50%; left: 0; right: 0;
    display: flex; justify-content: space-between;
    padding: 0 0.75rem; transform: translateY(-50%);
    z-index: 5; pointer-events: none;
  }
  .c-arrow {
    width: 30px; height: 30px; border-radius: 50%;
    border: 1px solid rgba(255,255,255,0.16);
    background: rgba(255,255,255,0.09);
    color: #fff; font-size: 17px; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    pointer-events: all; transition: all 0.2s ease; line-height: 1;
    backdrop-filter: blur(14px) saturate(1.4);
    -webkit-backdrop-filter: blur(14px) saturate(1.4);
  }
  .c-arrow:hover { background: rgba(59,130,246,0.28); border-color: rgba(59,130,246,0.52); }

  .c-dots {
    position: absolute; bottom: 0.85rem;
    left: 50%; transform: translateX(-50%);
    display: flex; gap: 4px; z-index: 5; align-items: center;
  }
  .c-dot {
    height: 2px; width: 14px; background: rgba(255,255,255,0.24);
    border: none; cursor: pointer; border-radius: 1px;
    transition: all 0.3s ease;
  }
  .c-dot.active { background: #3b82f6; width: 24px; }

  .c-counter {
    position: absolute; top: 0.8rem; right: 1rem;
    font-size: 9px; letter-spacing: 0.1em;
    color: rgba(255,255,255,0.28); z-index: 5;
  }

  /* ── GALLERY SECTION ── */
  .g-section {
    max-width: 1280px; margin: 0 auto;
    padding: 4rem clamp(1.25rem, 5vw, 3.5rem) 6rem;
  }
  .g-header {
    display: flex; align-items: flex-end;
    justify-content: space-between; flex-wrap: wrap;
    gap: 1.25rem; margin-bottom: 2.5rem;
  }
  .g-title {
    font-family: Arial, Helvetica, sans-serif;
    font-size: clamp(2rem, 4.5vw, 3.75rem);
    font-weight: 700;
    color: black;
    line-height: 1;
    letter-spacing: -0.02em;
  }
  .g-title em { font-style: italic; color: #2563eb; }
  .g-count { font-size: 11px; color: rgba(29,29,31,0.36); letter-spacing: 0.08em; margin-top: 5px; }

  .filter-row { display: flex; flex-wrap: wrap; gap: 5px; }
  .f-btn {
    padding: 5px 13px; font-size: 10px; letter-spacing: 0.16em; text-transform: uppercase;
    border: 1px solid rgba(29,29,31,0.12); background: transparent;
    color: rgba(29,29,31,0.42); cursor: pointer; border-radius: 2px;
    transition: all 0.2s ease; font-family: inherit;
  }
  .f-btn:hover, .f-btn.on {
    border-color: rgba(59,130,246,0.48); color: #2563eb;
    background: rgba(59,130,246,0.05);
  }

  .g-grid { columns: 3; column-gap: 10px; }
  @media (max-width: 860px) { .g-grid { columns: 2; } }
  @media (max-width: 500px) { .g-grid { columns: 1; } }

  .g-item {
    break-inside: avoid; margin-bottom: 10px;
    position: relative; overflow: hidden; cursor: pointer;
    background: #e5e5ea; border-radius: 10px; display: block;
  }
  .g-item img {
    width: 100%; display: block; border-radius: 10px;
    transition: transform 0.6s cubic-bezier(0.25,0.46,0.45,0.94), filter 0.35s ease;
    filter: brightness(0.96) saturate(0.88);
  }
  .g-item:hover img { transform: scale(1.06); filter: brightness(0.52) saturate(1.05); }

  .g-overlay {
    position: absolute; inset: 0; display: flex; flex-direction: column;
    justify-content: flex-end; padding: 1rem;
    background: linear-gradient(to top, rgba(0,0,0,0.66) 0%, transparent 52%);
    border-radius: 10px; opacity: 0; transition: opacity 0.3s ease;
  }
  .g-item:hover .g-overlay { opacity: 1; }
  .g-name {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1rem; font-weight: 700; color: #fff; line-height: 1.2;
  }
  .g-by { font-size: 10px; color: rgba(255,255,255,0.46); margin-top: 2px; letter-spacing: 0.04em; }
  .g-tag {
    position: absolute; top: 9px; right: 9px;
    font-size: 8px; letter-spacing: 0.18em; text-transform: uppercase;
    color: #3b82f6; border: 1px solid rgba(59,130,246,0.26);
    padding: 3px 7px; background: rgba(245,245,247,0.80);
    opacity: 0; transition: opacity 0.3s ease;
    backdrop-filter: blur(8px); border-radius: 3px;
  }
  .g-item:hover .g-tag { opacity: 1; }

  /* ── LOADER ── */
  .g-loader {
    display: flex; flex-direction: column; align-items: center;
    justify-content: center; min-height: 40vh; gap: 1rem;
  }
  .spinner {
    width: 28px; height: 28px;
    border: 1.5px solid rgba(59,130,246,0.14);
    border-top-color: #3b82f6; border-radius: 50%;
    animation: spin 0.7s linear infinite;
  }
  .spin-label { font-size: 10px; letter-spacing: 0.22em; text-transform: uppercase; color: rgba(29,29,31,0.28); }

  /* ─────────────────────────────────────────────────────────────
     MODAL — true iPhone material glass
     Dark charcoal tint + heavy blur — NOT white
  ───────────────────────────────────────────────────────────── */
  .modal-wrap {
    position: fixed; inset: 0; z-index: 9999;
    display: flex; align-items: center; justify-content: center;
    padding: clamp(0.75rem, 3vw, 2rem);
    animation: fadein 0.22s ease;
  }
  .modal-bg {
    position: absolute; inset: 0;
    background: rgba(0,0,0,0.35);
    backdrop-filter: blur(30px) saturate(1.5) brightness(0.72);
    -webkit-backdrop-filter: blur(30px) saturate(1.5) brightness(0.72);
    cursor: pointer;
  }
  .modal-glass {
    position: relative; z-index: 1;
    width: 100%; max-width: 1020px; max-height: 94vh;
    display: flex; flex-direction: column;
    border-radius: 20px; overflow: hidden;
    background: rgba(20, 20, 24, 0.80);
    border: 0.5px solid rgba(255,255,255,0.08);
    box-shadow:
      0 0 0 0.5px rgba(255,255,255,0.05) inset,
      0 2px 0 rgba(255,255,255,0.04) inset,
      0 40px 120px rgba(0,0,0,0.72),
      0 6px 18px rgba(0,0,0,0.32);
    backdrop-filter: blur(80px) saturate(2.6) brightness(0.86);
    -webkit-backdrop-filter: blur(80px) saturate(2.6) brightness(0.86);
    animation: slideup 0.32s cubic-bezier(0.16,1,0.3,1);
  }

  .modal-img-area {
    flex: 1; min-height: 0;
    background: #000;
    display: flex; align-items: center; justify-content: center;
    overflow: hidden; position: relative;
    cursor: zoom-in;
  }
  .modal-img-area.zoomed   { cursor: grab; }
  .modal-img-area.dragging { cursor: grabbing; }
  .modal-img-wrap {
    width: 100%; height: 100%;
    display: flex; align-items: center; justify-content: center;
    overflow: hidden;
  }
  .modal-img-area img {
    max-width: 100%;
    max-height: 76vh;
    width: auto; height: auto;
    object-fit: contain; display: block;
    transition: transform 0.24s cubic-bezier(0.25,0.46,0.45,0.94);
    transform-origin: center center;
    user-select: none; -webkit-user-drag: none;
  }

  .zoom-bar {
    position: absolute; top: 10px; left: 50%; transform: translateX(-50%);
    display: flex; align-items: center; gap: 6px;
    background: rgba(12,12,16,0.65);
    border: 0.5px solid rgba(255,255,255,0.10);
    border-radius: 20px; padding: 4px 10px;
    backdrop-filter: blur(20px); z-index: 10;
    opacity: 0; pointer-events: none; transition: opacity 0.24s;
  }
  .zoom-bar.visible { opacity: 1; pointer-events: all; }
  .zoom-bar button {
    background: none; border: none; color: rgba(255,255,255,0.58);
    font-size: 14px; cursor: pointer; padding: 0 2px; line-height: 1;
    transition: color 0.15s;
  }
  .zoom-bar button:hover { color: #60a5fa; }
  .zoom-pct {
    font-size: 9px; color: rgba(255,255,255,0.34);
    letter-spacing: 0.06em; min-width: 30px; text-align: center;
  }
  .zoom-hint {
    position: absolute; bottom: 9px; left: 50%; transform: translateX(-50%);
    font-size: 9px; letter-spacing: 0.09em; text-transform: uppercase;
    color: rgba(255,255,255,0.18);
    background: rgba(0,0,0,0.30); padding: 3px 9px; border-radius: 20px;
    pointer-events: none; white-space: nowrap;
  }

  .modal-close {
    position: absolute; top: 11px; right: 11px;
    width: 26px; height: 26px; border-radius: 50%;
    border: 0.5px solid rgba(255,255,255,0.10);
    background: rgba(48,48,54,0.70); color: rgba(255,255,255,0.60);
    font-size: 11px; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    z-index: 12; transition: all 0.18s; line-height: 1;
  }
  .modal-close:hover { background: rgba(190,42,42,0.48); border-color: rgba(215,55,55,0.36); color: #fff; }

  .modal-foot {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0.82rem 1.25rem;
    border-top: 0.5px solid rgba(255,255,255,0.06);
    background: rgba(10,10,12,0.52);
    flex-shrink: 0; gap: 1rem;
  }
  .m-title {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1.08rem; color: rgba(255,255,255,0.88); line-height: 1.2; font-weight: 700;
  }
  .m-sub { font-size: 10px; color: rgba(255,255,255,0.32); margin-top: 2px; letter-spacing: 0.04em; }
  .m-cat {
    display: inline-block; font-size: 8px; letter-spacing: 0.18em; text-transform: uppercase;
    color: #60a5fa; border: 0.5px solid rgba(96,165,250,0.26);
    padding: 2px 6px; margin-left: 8px; border-radius: 3px; vertical-align: middle;
  }
  .modal-nav { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }
  .m-nav-btn {
    width: 30px; height: 30px; border-radius: 50%;
    border: 0.5px solid rgba(255,255,255,0.10);
    background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.60);
    font-size: 16px; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s ease; line-height: 1;
  }
  .m-nav-btn:hover { background: rgba(59,130,246,0.22); border-color: rgba(59,130,246,0.45); color: #60a5fa; }
  .m-idx { font-size: 10px; color: rgba(255,255,255,0.22); letter-spacing: 0.07em; min-width: 34px; text-align: center; }

  @keyframes spin    { to { transform: rotate(360deg); } }
  @keyframes fadein  { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slideup {
    from { opacity: 0; transform: translateY(20px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0)    scale(1);    }
  }
`;

// ─── Zoom hook ────────────────────────────────────────────────────────────────
function useZoom(imageKey) {
  const [scale,  setScale]  = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [drag,   setDrag]   = useState(false);
  const dragStart = useRef(null);
  const imgRef    = useRef(null);

  useEffect(() => { setScale(1); setOffset({ x: 0, y: 0 }); }, [imageKey]);

  const clampOffset = useCallback((sc, ox, oy) => {
    const el = imgRef.current;
    if (!el) return { x: ox, y: oy };
    const maxX = Math.max(0, (el.offsetWidth  * (sc - 1)) / 2);
    const maxY = Math.max(0, (el.offsetHeight * (sc - 1)) / 2);
    return {
      x: Math.min(maxX, Math.max(-maxX, ox)),
      y: Math.min(maxY, Math.max(-maxY, oy)),
    };
  }, []);

  const applyZoom = useCallback((delta) => {
    setScale((prev) => {
      const next = Math.min(5, Math.max(1, prev + delta));
      if (next === 1) setOffset({ x: 0, y: 0 });
      return next;
    });
  }, []);

  const reset = useCallback(() => { setScale(1); setOffset({ x: 0, y: 0 }); }, []);

  const onWheel = useCallback((e) => {
    e.preventDefault();
    applyZoom(e.deltaY < 0 ? 0.5 : -0.5);
  }, [applyZoom]);

  const onMouseDown = useCallback((e) => {
    if (scale <= 1) return;
    e.preventDefault();
    setDrag(true);
    dragStart.current = { mx: e.clientX, my: e.clientY, ox: offset.x, oy: offset.y };
  }, [scale, offset]);

  const onMouseMove = useCallback((e) => {
    if (!drag || !dragStart.current) return;
    const dx = e.clientX - dragStart.current.mx;
    const dy = e.clientY - dragStart.current.my;
    setOffset(clampOffset(scale, dragStart.current.ox + dx, dragStart.current.oy + dy));
  }, [drag, scale, clampOffset]);

  const onMouseUp  = useCallback(() => { setDrag(false); }, []);

  const onAreaClick = useCallback(() => {
    if (scale <= 1) applyZoom(1.5);
    else reset();
  }, [scale, applyZoom, reset]);

  return { scale, offset, drag, imgRef, onWheel, onMouseDown, onMouseMove, onMouseUp, onAreaClick, applyZoom, reset };
}

// ─── Gallery component ────────────────────────────────────────────────────────
export default function Gallery() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [slide,   setSlide]   = useState(0);
  const [filter,  setFilter]  = useState("All");
  const [modal,   setModal]   = useState(null);
  const modalRef = useRef(null);
  const zoom = useZoom(modal?.id);

  useEffect(() => {
    fetchGallery().then((d) => { setData(d); setLoading(false); });
  }, []);

  useEffect(() => {
    if (!data) return;
    const t = setInterval(() => setSlide((i) => (i + 1) % data.featured.length), 5500);
    return () => clearInterval(t);
  }, [data]);

  const step = useCallback(
    (m, dir) => {
      const len = m.items.length;
      const idx = ((m.idx + dir) + len) % len;
      setModal({ ...m.items[idx], items: m.items, idx });
      zoom.reset();
    },
    [zoom]
  );

  useEffect(() => { modalRef.current = modal; }, [modal]);

  useEffect(() => {
    const handle = (e) => {
      const m = modalRef.current;
      if (!m) return;
      if (e.key === "Escape")     { setModal(null); return; }
      if (e.key === "ArrowRight") step(m,  1);
      if (e.key === "ArrowLeft")  step(m, -1);
    };
    window.addEventListener("keydown", handle);
    return () => window.removeEventListener("keydown", handle);
  }, [step]);

  function openModal(item, items) {
    const idx = items.findIndex((i) => i.id === item.id);
    setModal({ ...item, items, idx });
  }

  const categories = data ? ["All", ...new Set(data.gallery.map((g) => g.category))] : [];
  const filtered   = data
    ? (filter === "All" ? data.gallery : data.gallery.filter((g) => g.category === filter))
    : [];

  return (
    <div className="g-root">
      <style>{CSS}</style>

      {/* ── HERO CAROUSEL ─────────────────────────────────────────────────── */}
      <div className="carousel-wrap">
        <div className="carousel">
          {loading ? (
            <div style={{ width: "100%", height: "100%", background: "#c7c7cc" }} />
          ) : (
            data.featured.map((s, i) => (
              <div
                key={s.id}
                className={`c-slide ${i === slide ? "active" : ""}`}
                onClick={() => openModal(s, data.featured)}
              >
                <img src={s.img} alt={s.title} />
                <div className="c-vignette" />
                <div className="c-text">
                  <p className="c-eyebrow">{s.category}</p>
                  <h1 className="c-title">{s.title}</h1>
                  <p className="c-subtitle">{s.subtitle}</p>
                  <div className="c-meta">
                    <span>{s.photographer}</span>
                    <span>{s.location}</span>
                  </div>
                </div>
              </div>
            ))
          )}

          {data && (
            <>
              <div className="c-counter">
                {String(slide + 1).padStart(2, "0")} / {String(data.featured.length).padStart(2, "0")}
              </div>
              <div className="c-controls">
                <button className="c-arrow"
                  onClick={(e) => { e.stopPropagation(); setSlide((i) => (i - 1 + data.featured.length) % data.featured.length); }}>
                  &#8249;
                </button>
                <button className="c-arrow"
                  onClick={(e) => { e.stopPropagation(); setSlide((i) => (i + 1) % data.featured.length); }}>
                  &#8250;
                </button>
              </div>
              <div className="c-dots">
                {data.featured.map((_, i) => (
                  <button key={i} className={`c-dot ${i === slide ? "active" : ""}`}
                    onClick={(e) => { e.stopPropagation(); setSlide(i); }} />
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      {/* ── GALLERY GRID ──────────────────────────────────────────────────── */}
      <section className="g-section">
        <div className="g-header">
          <div>
            <h2 className="g-title">The <em>Archives</em></h2>
            {data && <p className="g-count">{filtered.length} works</p>}
          </div>
          <div className="filter-row">
            {categories.map((cat) => (
              <button key={cat} className={`f-btn ${filter === cat ? "on" : ""}`} onClick={() => setFilter(cat)}>
                {cat}
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="g-loader">
            <div className="spinner" />
            <p className="spin-label">Loading gallery</p>
          </div>
        ) : (
          <div className="g-grid">
            {filtered.map((item) => (
              <div key={item.id} className="g-item" onClick={() => openModal(item, filtered)}>
                <img src={item.img} alt={item.title} loading="lazy" />
                <div className="g-overlay">
                  <p className="g-name">{item.title}</p>
                  <p className="g-by">by {item.photographer}</p>
                </div>
                <span className="g-tag">{item.category}</span>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* ── MODAL ─────────────────────────────────────────────────────────── */}
      {modal && (
        <div className="modal-wrap">
          <div className="modal-bg" onClick={() => setModal(null)} />
          <div className="modal-glass">
            <button className="modal-close" onClick={() => setModal(null)}>✕</button>

            <div className={`zoom-bar ${zoom.scale > 1 ? "visible" : ""}`}>
              <button onClick={() => zoom.applyZoom(-0.5)}>−</button>
              <span className="zoom-pct">{Math.round(zoom.scale * 100)}%</span>
              <button onClick={() => zoom.applyZoom(0.5)}>+</button>
              <button onClick={zoom.reset} style={{ fontSize: 9, letterSpacing: "0.06em" }}>Reset</button>
            </div>

            <div
              className={`modal-img-area${zoom.scale > 1 ? " zoomed" : ""}${zoom.drag ? " dragging" : ""}`}
              onWheel={zoom.onWheel}
              onMouseDown={zoom.onMouseDown}
              onMouseMove={zoom.onMouseMove}
              onMouseUp={zoom.onMouseUp}
              onMouseLeave={zoom.onMouseUp}
              onClick={zoom.scale <= 1 ? zoom.onAreaClick : undefined}
            >
              <div className="modal-img-wrap">
                <img
                  ref={zoom.imgRef}
                  src={modal.img}
                  alt={modal.title}
                  style={{
                    transform: `scale(${zoom.scale}) translate(${zoom.offset.x / zoom.scale}px, ${zoom.offset.y / zoom.scale}px)`,
                    transition: zoom.drag ? "none" : undefined,
                  }}
                  draggable={false}
                />
              </div>
              {zoom.scale <= 1 && <div className="zoom-hint">scroll or click to zoom</div>}
            </div>

            <div className="modal-foot">
              <div>
                <p className="m-title">
                  {modal.title}
                  <span className="m-cat">{modal.category}</span>
                </p>
                <p className="m-sub">
                  by {modal.photographer}{modal.location ? ` · ${modal.location}` : ""}
                </p>
              </div>
              <div className="modal-nav">
                <button className="m-nav-btn" onClick={() => step(modal, -1)}>&#8249;</button>
                <span className="m-idx">{modal.idx + 1} / {modal.items.length}</span>
                <button className="m-nav-btn" onClick={() => step(modal, 1)}>&#8250;</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
